import React, { type ReactElement } from 'react';
import { initialQuery } from '@atlassian/jira-boards-main/src/model/constants.tsx';
import type { Query } from '@atlassian/jira-boards-main/src/model/index.tsx';
import QueryParamAdapter from '@atlassian/jira-common-directory-v2/src/query-param-adapter/index.tsx';
import type { Location } from '@atlassian/react-resource-router';
import { filterFromParams, filterToParams } from './transformers/filter.tsx';
import { sortFieldFromParam, sortFieldToParam } from './transformers/sort-field.tsx';

type Props = {
	location: Location;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	children: (arg1: { query: Query; onQueryChanged: (arg1: Query) => any }) => ReactElement;
};

const QueryParamAdapterWithSortingAndFiltering = ({
	location,
	children,
}: Props): React.JSX.Element => (
	<QueryParamAdapter
		location={location}
		sortFieldToParam={sortFieldToParam}
		sortFieldFromParam={sortFieldFromParam}
		filterFromParams={filterFromParams}
		filterToParams={filterToParams}
		defaultQuery={initialQuery}
	>
		{children}
	</QueryParamAdapter>
);

export default QueryParamAdapterWithSortingAndFiltering;
